import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
import {mapFormToApi} from "../../../redux/mappers/Customer/regMapper"

export const organizationRegApi = createApi({
  reducerPath: "organizationRegApi",
  baseQuery,
  tagTypes: ["Reg"],
  endpoints: (builder) => ({
    getRegByMasterId: builder.query({
      query: ({ id }) => {
        return `/customers/registration/${id}`;
      },

      transformResponse: (response) => {
        const data = response?.data?.map((item) => ({
          ...item,
          id: item.customerRegistrationId,
        }));

        return data;
      },

      providesTags: ["Reg"],
    }),

    // 🔄 UPDATE entity
    updateReg: builder.mutation({
      query: ({ id,subId, ...data }) => {
        const payload = {
          reg: mapFormToApi(data)   // ✔ Correct mapping
        };
        return {
        url: `/customers/registration/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body:  payload,
      };
      },
      invalidatesTags: ["Reg"],
    }),


    // 🔄 CREATE entity
    createReg: builder.mutation({
      query: ({ id, ...data }) => {
        const payload = {
          reg: mapFormToApi(data)   // ✔ Correct mapping
        };
    
        console.log("📦 Create payload:", payload);
    
        return {
          url: `/customers/registration/${id}`,
          method: "PUT",
          headers: {
            "X-Request-Id": Math.random().toString(36).substring(2),
          },
          body: payload,   // ✔ send correct payload
        };
      },
      invalidatesTags: ["Reg"],
    }),
        // 🔄 DELETE entity
        deleteReg: builder.mutation({
          query: ({ id, subId }) => ({
            url: `customers/${id}/${subId}`,
            method: "DELETE",
          }),
          invalidatesTags: ["Reg"],
        }),
    
  }),
});

export const {
  useGetRegByMasterIdQuery,
  useLazyGetRegByMasterIdQuery,
  useUpdateRegMutation,
  useDeleteRegMutation,
  useCreateRegMutation,
} = organizationRegApi;
